<template>
    <div ref="scheduler"></div>
</template>
<script>
import 'dhtmlx-scheduler'

export default {
    name: 'scheduler',
    props: {
        events: {
            type: Array,
            default() {
                return {events: []}
            }
        },
    },
    data() {
        return {
            alert_opts: [
                {key: 1, label: 'None'},
                {key: 2, label: 'On start date'},
                {key: 3, label: '1 day before'}
            ]
        }
    },
    mounted: function () {
        scheduler.skin = "material";
        scheduler.config.header = [
            "day",
            "week",
            "month",
            "date",
            "prev",
            "today",
            "next"
        ];
        this.$_initSchedulerEvents();
        scheduler.config.server_utc = false;
        scheduler.config.limit_time_select=true;
        scheduler.config.hour_size_px = 88; //sets the height of the X-Axis
        scheduler.config.readonly = true;
        scheduler.config.all_timed = "short"; // only events < 24 hours will be displayed as usual ones
        scheduler.config.multi_day = true; // rest of multiday events would be displayed at the top
        scheduler.config.details_on_create = true;
        scheduler.config.month_day_min_height = 150;
        scheduler.config.time_step = 1;
        scheduler.config.hour_date = "%h:%i %A";
        scheduler.config.event_duration = 60;
        scheduler.config.auto_end_date = false;
        scheduler.config.start_on_monday = false;
        scheduler.config.event_dy = 0; // Vertical offset
        scheduler.config.event_dx = 0; // Horizontal offset
        scheduler.templates.event_class = function(start, end, event) {
            return "my_event";

        };
        //scheduler.config.max_month_events = 1;
        // scheduler.config.first_hour = 9;
        // scheduler.config.last_hour = 20;
        scheduler.xy.scale_width = 100;
        scheduler.config.mark_now = true;
        scheduler.config.now_date= new Date();
        scheduler.config.scroll_hour = new Date().getHours();

        scheduler.init(this.$refs.scheduler, new Date(), "month");
        //  console.log('events', this.$props.events);
    },
    watch: {
        events(nv) {
            scheduler.clearAll();
            scheduler.config.server_utc = false;
            scheduler.parse(JSON.parse(JSON.stringify(nv)));
        }

    }, methods: {
        $_initSchedulerEvents: function () {
            if (!scheduler.$_eventsInitialized) {
                scheduler.attachEvent("onClick", (id, e) => {
                    //any custom logic here
                    const event = scheduler.getEvent(id);
                    this.$emit("editEvent", event);
                    return true;
                });
                scheduler.attachEvent("onTemplatesReady", function (eve) {
                    // scheduler.templates.event_header = function (start, end, ev) {
                    //     return "<b>" + ev.header + "</b><br>";
                    // };
                    scheduler.templates.event_text = function (start, end, e) {
                        return "<i>" + e.text + "</i>";
                    }
                });

                /*        scheduler.attachEvent("onEventAdded", (id, ev) => {
                            console.log('event', id);
                            console.log('ev', ev);
                            this.$emit("event-updated", id, "inserted", ev);
                        });
                        scheduler.attachEvent("onEventChanged", (id, ev) => {

                            console.log('onEventChanged', id);
                            console.log('onEventChanged', ev);
                            this.$emit("event-updated", id, "updated", ev);
                        });
                        scheduler.attachEvent("onEventDeleted", (id, ev) => {

                            console.log('onEventDeleted', id);
                            console.log('onEventDeleted', ev);
                            this.$emit("event-updated", id, "deleted");
                        });
                        // adds a handler for the 'onclick' event
                        scheduler.event("text", "click", function (e) {
                            //e - a native event object
                            alert("called");
                        });
                        scheduler.config.lightbox.sections = [
                            {name: "Select File", height: 40, map_to: "type", type: "select", options: this.alert_opts ,},
                            {name: "Select Users", height: 40, map_to: "type", type: "select", options: this.alert_opts ,},
                            {name: "Select Sales", height: 40, map_to: "type", type: "select", options: this.alert_opts ,},
                            {name: "Description", height: 50, map_to: "text", type: "textarea", focus: true},
                            {name: "time", height: 72, type: "time", map_to: "auto"}
                        ];*/
                scheduler.$_eventsInitialized = true;
            }
        },
    }
}
</script>

<style>
.dhx_body {
    width: auto !important;
}
/* background color for whole container and it's border*/
.my_event {
    border: 1px solid #778899 !important;
    overflow: hidden !important;
}
.dhx_scheduler_month .my_event{
    //width: 10.5vw !important;
    margin-left: 10px;
}
.dhx_scale_hour{
    border-bottom: 1px solid #e0e0e0;
    background-color: #fff;
    text-align: center;
    line-height: 44px;
    color: rgba(0,0,0,.54);
    font-size: 16px !important;
    font-weight: 500;
    overflow: hidden;
}
@import "~dhtmlx-scheduler/codebase/dhtmlxscheduler_material.css";
</style>
